import React, {Component} from 'react'
import {BrowserRouter, Route, Routes, useParams} from 'react-router-dom';
import './helpers/rendererHelper'
import {convertTokensParamToArray} from './helpers/tokenHelper'
import PlayerSuper from './components/Player/PlayerSuper'
import PlayerBig from './components/Player/PlayerBig'
import PlayerMedium from './components/Player/PlayerMedium';
import PlayerSmall from './components/Player/PlayerSmall';
import PlayerMini from './components/Player/PlayerMini';
import AppConfig from './config/config.json';
import Error404 from "./components/Error/Error404";
import PlayerSuperExtended from "./components/Player/PlayerSuperExtended";
import './front/css/reset.css';
import './front/css/main.css';
import PlayerSuperSmall from "./components/Player/PlayerSuperSmall";
import SplitHistory from "./components/Player/SplitHistory";

class App extends Component {
    render() {
        let urlParams = new URLSearchParams(window.location.search);
        let locale = urlParams.get("locale");
        let autoplay = urlParams.get("autoplay");
        let preview = urlParams.get("preview");
        let autoDesign = urlParams.get("autodesign");
        let bufferPreviewed = urlParams.get("bufferPreviewed");
        let onChangeCommittedFlush = urlParams.get("onChangeCommittedFlush");
        let url = urlParams.get("url");
        let scale = urlParams.get("scale");
        let params = window.location.search;
        if (url) {
            params = params.replace('url=' + url, '');
        }
        let tokens = convertTokensParamToArray(params.substring(1));

        // Used for player in _blank window
        if (scale) {
            let scaleCalc = 0.5 * (scale - 100);
            document.documentElement.style.cssText = "scale:" + scale / 100 + ";position:relative;top:" + scaleCalc + "%;left:" + scaleCalc + "%;"
        }

        const PlayerSuperExtendedRoute = function () {
            let {configId, templateName} = useParams();
            return <PlayerSuperExtended configId={configId} templateName={templateName} locale={locale}
                                        autoplay={autoplay} preview={preview} url={url} autoDesign={autoDesign}
                                        tokens={tokens} bufferPreviewed={bufferPreviewed}
                                        onChangeCommittedFlush={onChangeCommittedFlush}/>;
        }

        const PlayerSuperRoute = function () {
            let {configId, templateName} = useParams();
            return <PlayerSuper configId={configId} templateName={templateName} locale={locale}
                                autoplay={autoplay} preview={preview} url={url} autoDesign={autoDesign}
                                tokens={tokens} bufferPreviewed={bufferPreviewed}
                                onChangeCommittedFlush={onChangeCommittedFlush}/>;
        }

        const PlayerBigRoute = function () {
            let {configId, templateName} = useParams();
            return <PlayerBig configId={configId} templateName={templateName} locale={locale}
                              autoplay={autoplay} preview={preview} url={url} tokens={tokens}
                              bufferPreviewed={bufferPreviewed}
                              onChangeCommittedFlush={onChangeCommittedFlush}/>;
        }

        const PlayerMediumRoute = function () {
            let {configId, templateName} = useParams();
            return <PlayerMedium configId={configId} templateName={templateName} locale={locale}
                                 autoplay={autoplay} preview={preview} url={url} tokens={tokens} splitHistoryRatio={1.8}
                                 bufferPreviewed={bufferPreviewed} onChangeCommittedFlush={onChangeCommittedFlush}/>;
        }

        const PlayerSmallRoute = function () {
            let {configId, templateName} = useParams();
            return <PlayerSmall configId={configId} templateName={templateName} locale={locale}
                                autoplay={autoplay} preview={preview} url={url} tokens={tokens} splitHistoryRatio={1.3}
                                bufferPreviewed={bufferPreviewed} onChangeCommittedFlush={onChangeCommittedFlush}/>;
        }

        const PlayerSuperSmallRoute = function (params) {
            if (AppConfig.env !== "dev" && params.isTest) {
                return "";
            }
            return <PlayerSuperSmall url={url} tokens={tokens}/>;
        }

        const PlayerMiniRoute = function (params) {
            if (AppConfig.env !== "dev" && params.isTest) {
                return "";
            }
            return <PlayerMini url={url} autoplay={autoplay} tokens={tokens}/>;
        }

        const PlayerHistoryRoute = function () {
            const {templateName, configId} = useParams();
            return <SplitHistory preview={preview} templateName={templateName} configId={configId}/>
        }

        return <BrowserRouter basename={AppConfig.basename}>
            <Routes>
                <Route path="/prod">
                    <Route path="extended/:configId" element={<PlayerSuperExtendedRoute/>}></Route>
                    <Route path="super/:configId" element={<PlayerSuperRoute/>}></Route>
                    <Route path="big/:configId" element={<PlayerBigRoute/>}></Route>
                    <Route path="medium/:configId" element={<PlayerMediumRoute/>}></Route>
                    <Route path="small/:configId" element={<PlayerSmallRoute/>}></Route>
                    <Route path="super_small" element={<PlayerSuperSmallRoute/>}></Route>
                    <Route path="mini" element={<PlayerMiniRoute/>}></Route>
                    <Route path="history/:configId" element={<PlayerHistoryRoute/>}></Route>
                    <Route path="history" element={<PlayerHistoryRoute/>}></Route>
                </Route>
                <Route path="/template">
                    <Route path="extended/:templateName" element={<PlayerSuperExtendedRoute/>}></Route>
                    <Route path="super/:templateName" element={<PlayerSuperRoute/>}></Route>
                    <Route path="big/:templateName" element={<PlayerBigRoute/>}></Route>
                    <Route path="medium/:templateName" element={<PlayerMediumRoute/>}></Route>
                    <Route path="small/:templateName" element={<PlayerSmallRoute/>}></Route>
                    <Route path="history/:templateName" element={<PlayerHistoryRoute/>}></Route>
                    <Route path="history" element={<PlayerHistoryRoute/>}></Route>
                </Route>
                <Route path="/404" element={<Error404/>}></Route>
                <Route path="*" element={<Error404/>}></Route>
            </Routes>

        </BrowserRouter>;
    }
}

export default App
